<template>
  <aside class="aside-menu">
    <div class="p-3 bg-light text-center font-weight-bold text-muted text-uppercase">
      Available Outlets : 
    </div>
    <label
      v-if="isOwner"
      @click="onOutletClick(-1)"
      class="p-3 outlet"
    >
      <div class="message">
        <div>
          <small class="text-muted"></small>
        </div>
        <div class="text-truncate font-weight-bold">
          All Outlet
          <input class="float-right" name="outlet" type="radio" :checked="isActiveOutlet(-1)">
        </div>
        <small class="text-muted">This option is choosed for reporting purposes</small>
      </div>
    </label>
    <label
      v-for="outlet in outlets"
      :key="outlet.id"
      @click="onOutletClick(outlet.id)"
      class="p-3 outlet"
    >
      <div class="message">
        <div>
          <small class="text-muted">{{ outlet.address }}</small>
        </div>
        <div class="text-truncate font-weight-bold">
          {{ outlet.name }}
          <input class="float-right" name="outlet" type="radio" :checked="isActiveOutlet(outlet.id)">
        </div>
        <small class="text-muted">{{ outlet.region.country.name }}</small>
      </div>
    </label>
  </aside>
</template>

<script>
import store from '@/store'
import { changeOutlet } from '@/services/auth'

export default {
  name: 'c-aside',
  data () {
    return {
      outlets: store.getters.outlets
    }
  },
  methods: {
    isActiveOutlet (outletID) {
      return outletID === store.getters.activeOutletID
    },
    onOutletClick (outletID) {
      if (outletID !== -1) {
        changeOutlet(outletID)
          .then(response => {
            console.log(response)
          })
        store.commit('changeIsAllOutlet', false)
      } else {
        store.commit('changeIsAllOutlet', true)
      }
    }
  },
  computed: {
    isOwner () {
      return this.$store.state.auth.user.username === 'owner'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue